"use client"

import { Card, Title, BigValue, Track, TrackBase, TrackFill, Scale, Marker } from './primitives'
import styled from "styled-components"

const Status = styled.p`
  font-size: 0.875rem;
  color: var(--color-optimal-foreground);
  margin: 0.125rem 0 0;
`

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

const HeaderRight = styled.div`
  text-align: right;
`

export default function ExpenseRatioCard() {
  const percent = (0.06 / 0.5) * 100
  return (
    <Card>
      <Header>
        <Title>Blended expense ratio</Title>
        <HeaderRight>
          <BigValue>0.06%</BigValue>
          <Status>Low cost</Status>
        </HeaderRight>
      </Header>

      <Track>
        <TrackBase>
          <TrackFill $width={percent} />
        </TrackBase>
        <Marker percent={percent} color="var(--color-optimal)" />
      </Track>
      <Scale>
        <span>0%</span>
        <span>Industry avg 0.24%</span>
        <span>0.5%</span>
      </Scale>
    </Card>
  )
}
